import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { useDisclosure, usePaginatedFilters } from 'further-ui/hooks';
import api from 'lib/trpcClient';
import { CalendarDayRange } from 'further-types/utils';

const orderByOptions = [
  'dateRange',
  'searchQuery',
  'realisationDate',
  'assetName',
  'status',
  'numberOfUnitsRealised',
  'totalRealisationAmountTcy',
  'totalRealisationAmountLcy',
] as const;

export default function useListRealisations(pageId: string, vehicleId: string) {
  const deleteDisclosure = useDisclosure<{ id: string }>();
  const { pagination, filters, handleChangeFilters } = usePaginatedFilters<
    {
      searchQuery: string;
      dateRange: CalendarDayRange | undefined;
    },
    (typeof orderByOptions)[number]
  >(pageId, {
    defaultFilters: {
      searchQuery: '',
      dateRange: undefined,
    },
    defaultOrder: {
      orderBy: 'realisationDate',
      order: 'desc',
    },
    orderByOptions,
  });

  const { data: realisations, isFetching } = api.lpRealisation.list.useQuery({
    vehicleId,
    ...pagination,
    dateRange: filters.dateRange,
    searchQuery: filters.searchQuery,
  });

  const mutationOptions = useHandleTrpcMutation()({
    successMessage: 'Realisation deleted successfully.',
  });

  const deleteRealisation =
    api.lpRealisation.remove.useMutation(mutationOptions);

  const handleDeleteRealisation = () => {
    deleteRealisation.mutate({
      realisationId: deleteDisclosure.actionProps.id,
      vehicleId,
    });
    deleteDisclosure.onClose();
  };

  const handleOpenDeleteDialog = (realisationId: string) => {
    deleteDisclosure.stageAction({ id: realisationId });
  };

  return {
    realisations: realisations?.results ?? [],
    totalCount: realisations?.totalCount ?? 0,
    isFetching,
    filters,
    handleChangeFilters,
    handleDeleteRealisation,
    pagination,
    isDeleteDialogOpen: deleteDisclosure.isOpen,
    handleCloseDeleteDialog: deleteDisclosure.onClose,
    handleOpenDeleteDialog,
  };
}
